import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateDashboardPart } from '../../../../actions/DashboardConfigActions';
import SavedSearchesTable from '../../../../components/SavedSearchesTable';
import { ENTITY_NAME_DASHBOARD } from '../../../../constants/SavedSearches';
import { equalityFn } from '../../../../form-designer/utils/form-manager.utils';
import { getSavedSearchResultsKey } from '../../../../reducers/SavedSearchResultsReducer';
import {
  getDashboardSavedSearches,
  getSavedSearchResultsState,
} from '../../../../selectors/DashboardSelectors';
import NavigateLinkCell from '../../../FindPage/NavigateLinkCell';
import CustomHeaderActions from '../CustomHeaderActions';

const DashboardPartBigTable = ({
  part,
  tab,
  mode,
  onEdit,
  onDelete,
  data,
  onUpdateData,
  lastSelectedSearchNames = {},
}) => {
  const { tabs } = part;
  const { editable, deletable, id } = tab;
  const configEntityName = tab.graph?.savedSearchByEntity?.entityName;
  const configSearchName = tab.graph?.savedSearchByEntity?.savedSearchName;
  const selectedSearchName = data?.savedSearchName;

  const dispatch = useDispatch();
  const dashboardSavedSearches = useSelector(getDashboardSavedSearches, equalityFn);
  const savedSearchResults = useSelector(getSavedSearchResultsState);
  const [title, setTitle] = useState('');
  const [savedSearchName, setSavedSearchName] = useState(configSearchName);
  const [savedSearchesNotEmpty, setSavedSearchesNotEmpty] = useState();
  const [selectedSearchParams, setSelectedSearchParams] = useState({});

  const isEditMode = mode === 'edit';

  useEffect(() => {
    if (configSearchName !== savedSearchName) {
      setSavedSearchName(configSearchName);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configEntityName, configSearchName]);

  useEffect(() => {
    if (isEditMode) {
      setSavedSearchName(configSearchName);
    } else {
      setSavedSearchName(selectedSearchName || configSearchName);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode]);

  useEffect(() => {
    const selectedSearchKey = getSavedSearchResultsKey(
      selectedSearchParams.selectedEntity,
      selectedSearchParams.savedSearchName,
      id
    );
    if (savedSearchResults[selectedSearchKey]) {
      const selectedSavedSearchResult =
        savedSearchResults?.[selectedSearchKey]?.results?.rows ?? [];

      setSavedSearchesNotEmpty(selectedSavedSearchResult.length !== 0);
    }
  }, [savedSearchResults, selectedSearchParams, id]);

  const handleSavedSearchChange = ({ entityName, savedSearchName }) => {
    const savedSearch = dashboardSavedSearches.find(
      (search) => search.searchName === savedSearchName
    );

    setTitle(savedSearch?.translatedSearchName ?? savedSearchName);
    setSelectedSearchParams({ selectedEntity: entityName, savedSearchName });

    if (!isEditMode && savedSearchName) {
      onUpdateData(tab.id, { entityName, savedSearchName });
      dispatch(
        updateDashboardPart(part.id, {
          part,
          tab: {
            ...tab,
            title: savedSearchName,
            graph: {
              savedSearchByEntity: {
                entityName,
                savedSearchName,
              },
            },
          },
        })
      );
    }
  };

  const savedSearchEntityName = isEditMode ? configEntityName : ENTITY_NAME_DASHBOARD;

  const initialSearchName = lastSelectedSearchNames[id] ?? savedSearchName;
  return (
    <div>
      <SavedSearchesTable
        title={title}
        dataKey={id}
        entityName={savedSearchEntityName}
        showSearchSelector={!isEditMode}
        enableSearchNameSearch={!isEditMode}
        initialSearchName={initialSearchName}
        rowsPerPageOptions={[10, 25, 50]}
        customCell={NavigateLinkCell.fromNavigationColumn}
        onSavedSearchChange={handleSavedSearchChange}
        hideAdvancedSearch={isEditMode}
        hideExport={!savedSearchesNotEmpty || isEditMode}
        CustomHeaderActions={() => (
          <CustomHeaderActions
            tabs={tabs}
            showEdit={editable && isEditMode}
            showDelete={deletable && isEditMode}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        )}
        active={isEditMode}
        groupByEntityName
        enableSorting
        enableSaving={true}
        showFilters
      />
    </div>
  );
};

export default DashboardPartBigTable;
